import IconButton from "@mui/material/IconButton";


import * as React from "react";
import Menu from "@mui/material/Menu";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {Avatar, ListItemText, Tooltip} from "@mui/material";

import ApproveOwed from "./StatusActions/ApproveOwed";
import DeferOwed from "./StatusActions/DeferOwed";
import FlagOwed from "./StatusActions/FlagOwed";
import HoldOwed from "./StatusActions/HoldOwed";
import PaidOwed from "./StatusActions/PaidOwed";
import UnapproveOwed from "./StatusActions/UnapproveOwed";
import RejectOwed from "./StatusActions/RejectOwed";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import UndoOwed from "./StatusActions/UndoOwed";
import IssuedOwed from "./StatusActions/IssueOwed";
import SetHistoryExpense from "./StatusActions/HistoryExpense";
import {useSelector} from "react-redux";
import IssueExpense from "./StatusActions/IssueExpense";
import RequestExpense from "./StatusActions/RequestExpense";
import RemittedExpense from "./StatusActions/RemittedExpense";
import NonPayingExpense from "./StatusActions/NonPayingExpense";


export default function WorkIssuanceStatusMenu({ rowCdpStatus}) {

    const showOwed = useSelector((state) => state.workIssuanceSlc.value.owedGridState)
    const showExpense = useSelector((state) => state.workIssuanceSlc.value.expenseGridState)


    const [anchorEl, setAnchorEl] = React.useState(null);

    const isMenuOpen = Boolean(anchorEl);


    const handleCrudMenuOpen = (event) => {
        console.log("this should be the index");
        // console.log(event.currentTarget.index);
  // if (rowCdpStatus === "3242") { return;}
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const crudId = 'primary-search-account-menu';

    const renderMenu = (

        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={crudId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >


            < ApproveOwed rowCdpStatus={rowCdpStatus} showOwed={showOwed} showExpense={showExpense} onMenuClose={handleMenuClose} />

            < UnapproveOwed rowCdpStatus={rowCdpStatus} showOwed={showOwed} showExpense={showExpense}  onMenuClose={handleMenuClose} />

            < DeferOwed rowCdpStatus={rowCdpStatus} showOwed={showOwed} showExpense={showExpense}  onMenuClose={handleMenuClose} />

            < RejectOwed rowCdpStatus={rowCdpStatus} showOwed={showOwed} showExpense={showExpense}  onMenuClose={handleMenuClose} />

            < NonPayingExpense rowCdpStatus={rowCdpStatus} showOwed={showOwed} showExpense={showExpense}  onMenuClose={handleMenuClose} />

            < SetHistoryExpense rowCdpStatus={rowCdpStatus} showOwed={showOwed} showExpense={showExpense}  onMenuClose={handleMenuClose} />

            < HoldOwed rowCdpStatus={rowCdpStatus} showOwed={showOwed} showExpense={showExpense}  onMenuClose={handleMenuClose} />

            < PaidOwed rowCdpStatus={rowCdpStatus} showOwed={showOwed} showExpense={showExpense}  onMenuClose={handleMenuClose} />

            < IssuedOwed rowCdpStatus={rowCdpStatus} showOwed={showOwed} showExpense={showExpense}  onMenuClose={handleMenuClose} />

            < RequestExpense rowCdpStatus={rowCdpStatus} showOwed={showOwed} showExpense={showExpense}  onMenuClose={handleMenuClose} />

            < RemittedExpense rowCdpStatus={rowCdpStatus} showOwed={showOwed} showExpense={showExpense} onMenuClose={handleMenuClose} />

            < IssueExpense rowCdpStatus={rowCdpStatus} showOwed={showOwed} showExpense={showExpense}  onMenuClose={handleMenuClose} />

            < UndoOwed rowCdpStatus={rowCdpStatus} showOwed={showOwed} showExpense={showExpense}  onMenuClose={handleMenuClose} />

        </Menu>
    );


    const getAvatar = (rowCdpStatus) => {

        // const cdpStatus  = row;
        switch (rowCdpStatus ) {
            case '2339':
                return (
                    <Tooltip title="Generated">
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14,  bgcolor:  'rgb(0,128,0)'
                            // color:    'rgb(0,128,0)'
                            // 'black', bgcolor: 'white'
                        }}>g</Avatar>
                    </Tooltip>
                );
            case '2040':
                return (
                    <Tooltip title="Unapproved">
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14, bgcolor: 'rgb(255,140,0)' }}>u</Avatar>
                    </Tooltip>
                );
            case '2039':
                return (
                    <Tooltip title="Approved">
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14, bgcolor: 'rgb(30,144,255)'
                            // , boxShadow: '0 0 0 1px white'
                            // 'rgb(0,128,0)'
                        }}>a</Avatar>
                    </Tooltip>
                );
            case '2043':
                return (
                    <Tooltip title="Deferred">
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14, bgcolor: 'rgb(169,169,169)' }}>d</Avatar>
                    </Tooltip>
                );
            case '2042':
                return (
                    <Tooltip title="Rejected">
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14, bgcolor: 'rgb(169,169,169)' }}>r</Avatar>
                    </Tooltip>
                );
            case '2041':
                return (
                    <Tooltip title="Held">
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14, bgcolor: 'black' }}>h</Avatar>
                    </Tooltip>
                );
            case '3208':
                return (
                    <Tooltip title="Blocked">
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14, bgcolor: 'black' }}>b</Avatar>
                    </Tooltip>
                );
            case '2602':
                return (
                    <Tooltip title="Flagged">
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14, bgcolor: '#d50000' }}>f</Avatar>
                    </Tooltip>
                );
            case '2044':
                return (
                    <Tooltip title="Committed">
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14, bgcolor: 'rgb(30,144,255)' }}>c</Avatar>
                    </Tooltip>
                );
            case '2351':
                return (
                    <Tooltip title="Paid">
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14, bgcolor: 'rgb(30,144,255)' }}>p</Avatar>
                    </Tooltip>
                );
            case '3706':
                return (
                    <Tooltip title="Test">
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14, bgcolor: '#673ab7' }}>t</Avatar>
                    </Tooltip>
                );
            case 'm':
                return (
                    <Tooltip title="Multiple">
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14, bgcolor: 'rgb(0,128,0)' }}>m</Avatar>
                    </Tooltip>
                );
            case '2359':
                return (
                    <Tooltip title="Requested">
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14, bgcolor: 'rgb(255,140,0)' }}>r</Avatar>
                    </Tooltip>
                );
            case '4553':
                return (
                    <Tooltip title="Remitted">
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14, bgcolor: 'rgb(0,128,0)' }}>r</Avatar>
                    </Tooltip>
                );
            case '3242':
                return (
                    <Tooltip title={<span style={{whiteSpace: 'pre-line'}}>
                    {"Issued"  +
                        "\nno actions allowed"
                    }</span>}>
                        <Avatar sx={{ height: 20, width: 20, fontSize: 14, bgcolor: 'rgb(30,144,255)'
                        }}>i</Avatar>
                    </Tooltip>
                );
            default:
                return (
                    <IconButton
                        size="large"
                        edge="end"
                        aria-label="account of current user"
                        aria-controls={crudId}
                        aria-haspopup="true"
                        color="inherit"
                    >
                        <MoreVertIcon  color="primary" fontSize="small"/>
                    </IconButton>
                );
                // return null;
        }
    };



    return (
        <div>
            <div onClick={handleCrudMenuOpen}>
                {getAvatar(rowCdpStatus)}
            </div>
            {renderMenu}
        </div>
    );
}